import { render, staticRenderFns } from "./VacancyItem.vue?vue&type=template&id=29e640ea"
import script from "./VacancyItem.vue?vue&type=script&lang=js"
export * from "./VacancyItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports